import I18n         from 'i18n-js'
import translations from '../locales/en.json'

I18n.defaultLocale = 'en'
I18n.locale        = 'en'
I18n.translations  = translations

export default I18n
